import { lazy } from 'react';
// project imports
import Loadable from 'ui-component/Loadable';

const AuditLogReport = Loadable(lazy(() => import('views/pages/reports/auditLog')));
const SystemAuditTrail = Loadable(lazy(() => import('views/pages/reports/systemAuditTrail')));
const ManagePickups = Loadable(lazy(() => import('views/pages/manage-pickups')));
const ViewGaiapod = Loadable(lazy(() => import('views/pages/manage-pickups/Gaiapod-management/viewGaiapod')));
const LostItemsList = Loadable(lazy(() => import('views/pages/manage-pickups/Lost-samples')));
const TrackingList = Loadable(lazy(() => import('views/pages/manage-pickups/Tracking')));
const TrackingHistoryPage = Loadable(lazy(() => import('views/pages/manage-pickups/Tracking/TrackingHistoryPage')));
const GaiapodList = Loadable(lazy(() => import('views/pages/manage-pickups/Gaiapod-management')));
const MapPage = Loadable(lazy(() => import('views/pages/manage-pickups/MapPage')));
const Intransit = Loadable(lazy(() => import('views/pages/manage-lab-test/InTransit')));

const EditTestTemplate = Loadable(lazy(() => import('views/pages/manage-test-requests/test-templates/edit-template')));
const ViewTemplateDetails = Loadable(lazy(() => import('views/pages/manage-test-requests/test-templates/view-details')));
const RestUserPassword = Loadable(lazy(() => import('views/pages/admin-users/reset-password')));
const EditUserData = Loadable(lazy(() => import('views/pages/admin-users/edit')));
const EditCustomerUser = Loadable(lazy(() => import('views/pages/manage-customer-users/edit-user')));
const RolesAccess = Loadable(lazy(() => import('views/pages/configuration/role-access')));
const AdminConfiguration = Loadable(lazy(() => import('views/pages/configuration')));
const ProductManagement = Loadable(lazy(() => import('views/pages/configuration/products-management')));
const DeliveryLocationManagement = Loadable(lazy(() => import('views/pages/configuration/delivery-address-management')));
const ViewUsersrDetails = Loadable(lazy(() => import('views/pages/admin-users/view-user')));
const GeneratedSampleId = Loadable(lazy(() => import('views/pages/manage-test-requests/generate-sample-id')));
const ResultEntryGrouped = Loadable(lazy(() => import('views/pages/manage-lab-test/scheduled-test/Result-Entry-grouped')));
const ResultViewPrintGroup = Loadable(lazy(() => import('views/pages/manage-lab-test/ResultGeneration/ResultViewPrintGroup')));
const CustomerUserDetails = Loadable(lazy(() => import('views/pages/manage-customer-users/view-user-details')));
const ReportsDashboard = Loadable(lazy(() => import('views/pages/reports')));
const SampleLogReport = Loadable(lazy(() => import('views/pages/reports/sampleLog')));
const ManageLabTest = Loadable(lazy(() => import('views/pages/manage-lab-test')));
const ScheduledList = Loadable(lazy(() => import('views/pages/manage-lab-test/scheduled-test')));
const SampleSplitting = Loadable(lazy(() => import('views/pages/manage-lab-test/SampleSplitting')));
const LabTestUnvalidList = Loadable(lazy(() => import('views/pages/manage-lab-test/LabTestUnvalidList')));
const ResultEntry = Loadable(lazy(() => import('views/pages/manage-lab-test/scheduled-test/Result-Entry')));
const Archival = Loadable(lazy(() => import('views/pages/manage-lab-test/Archival')));
const Disposal = Loadable(lazy(() => import('views/pages/manage-lab-test/Disposal')));
const UnfitSample = Loadable(lazy(() => import('views/pages/manage-lab-test/Unfit')));
const NonConfermance = Loadable(lazy(() => import('views/pages/manage-lab-test/scheduled-test/Non-Conformance')));
const ResultGenerationList = Loadable(lazy(() => import('views/pages/manage-lab-test/ResultGeneration')));
const ResultViewPrint = Loadable(lazy(() => import('views/pages/manage-lab-test/ResultGeneration/ResultViewPrintSingle')));
const EditTestSample = Loadable(lazy(() => import('views/pages/manage-test-requests/edit-test-request')));
const ViewTestRequest = Loadable(lazy(() => import('views/pages/manage-test-requests/view-test-request')));
const LookupMaster = Loadable(lazy(() => import('views/pages/configuration/lookup-master')));
const CustomerMangement = Loadable(lazy(() => import('views/pages/manage-customer')));
const CustomerUsersMangement = Loadable(lazy(() => import('views/pages/manage-customer-users')));
const AddClientUser = Loadable(lazy(() => import('views/pages/manage-customer-users/add-customer-user')));
const AddNewCustomer = Loadable(lazy(() => import('views/pages/manage-customer/add-new-customer')));
const EditClient = Loadable(lazy(() => import('views/pages/manage-customer/edit-customer')));
const ViewClientDetails = Loadable(lazy(() => import('views/pages/manage-customer/view-customer')));

const BranchManagement = Loadable(lazy(() => import('views/pages/manage-branch')));
const AddNewBranch = Loadable(lazy(() => import('views/pages/manage-branch/add-new-branch')));
const EditBranch = Loadable(lazy(() => import('views/pages/manage-branch/edit-branch')));
const ViewBranchDetails = Loadable(lazy(() => import('views/pages/manage-branch/view-branch')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const Users = Loadable(lazy(() => import('views/pages/admin-users')));
const TestRequests = Loadable(lazy(() => import('views/pages/manage-test-requests/test-requests-list')));
const ManageTestRequest = Loadable(lazy(() => import('views/pages/manage-test-requests')));
const AddUser = Loadable(lazy(() => import('views/pages/admin-users/add-new-user')));
const TestTemplateList = Loadable(lazy(() => import('views/pages/manage-test-requests/test-templates/list-view')));
const AddTestTemplate = Loadable(lazy(() => import('views/pages/manage-test-requests/test-templates/add-template')));
const NewTestSample = Loadable(lazy(() => import('views/pages/manage-test-requests/new-test-sample')));
const CostManagement = Loadable(lazy(() => import('views/pages/financial-management/cost-management')));
const AddCostingCard = Loadable(lazy(() => import('views/pages/financial-management/cost-management/add-cost-card')));
// Financial Management
const FinancilaDashboard = Loadable(lazy(() => import('views/pages/financial-management')));
const BillingAndInvoiceManagement = Loadable(lazy(() => import('views/pages/financial-management/billing-management')));
const CreateNewInvoice = Loadable(lazy(() => import('views/pages/financial-management/billing-management/add-invoice')));
const PricingManagement = Loadable(lazy(() => import('views/pages/financial-management/pricing-management/pricingLog')));

const InvoiceDetails = Loadable(lazy(() => import('views/pages/financial-management/billing-management/view-invoice')));
const InvoiceDetailsReport = Loadable(lazy(() => import('views/pages/financial-management/invoice-details/InvoiceDetails')));
const InvoiceEdit = Loadable(lazy(() => import('views/pages/financial-management/billing-management/edit-invoice')));
const PermissionList = Loadable(lazy(() => import('views/pages/configuration/role-access/PermissionList/PermissionList')));
// ==============================|| MAIN ROUTING ||============================== //

const MapRoutes = [
    {
        path: '/',
        element: DashboardDefault,
        screenKeyName: 'DASHBOARD'
    },
    // Configuration
    {
        path: '/configuration',
        element: AdminConfiguration,
        screenKeyName: 'CONFIGURATION'
    },
    {
        path: '/configuration/products-management',
        element: ProductManagement,
        screenKeyName: 'VIEW_PRODUCT_LIST'
    },
    {
        path: '/configuration/delivery-location-management',
        element: DeliveryLocationManagement,
        screenKeyName: 'VIEW_LAB_ADDRESS_LIST'
    },
    // ProductManagement
    {
        path: '/configuration/master-lookups',
        element: LookupMaster,
        screenKeyName: 'VIEW_LOOKUP_LIST'
    },
    {
        path: '/configuration/role-permissions',
        element: RolesAccess,
        screenKeyName: 'VIEW_SYSTEM_ROLE_LIST'
    },
    // Customer Management
    {
        path: '/configuration/customer-management',
        element: CustomerMangement,
        screenKeyName: 'VIEW_LAB_CUSTOMER_LIST'
    },
    {
        path: '/configuration/customer-management/add-customer',
        element: AddNewCustomer,
        screenKeyName: 'ADD_CUSTOMER'
    },
    {
        path: '/configuration/customer-management/:id/edit',
        element: EditClient,
        screenKeyName: 'EDIT_UPDATE_CUSTOMER'
    },
    {
        path: '/configuration/customer-management/:id/view',
        element: ViewClientDetails,
        screenKeyName: 'VIEW_CUSTOMER_DETAILS'
    },
    {
        path: '/configuration/customer-management/:id/user-management',
        element: CustomerUsersMangement,
        screenKeyName: 'VIEW_CUSTOMER_USERS_LIST'
    },
    {
        path: '/configuration/customer-management/:id/user-management/:user_id/user_details',
        element: CustomerUserDetails,
        screenKeyName: 'VIEW_CUSTOMER_USER'
    },
    {
        path: '/configuration/customer-management/:id/user-management/:user_id/edit_details',
        element: EditCustomerUser,
        screenKeyName: 'EDIT_UPDATE_CUSTOMER_USER'
    },
    {
        path: '/configuration/customer-management/:id/user-management/add-user',
        element: AddClientUser,
        screenKeyName: 'ADD_CUSTOMER_USER'
    },
    // Branch Management
    {
        path: '/branch-management',
        element: BranchManagement,
        screenKeyName: 'BRANCH_LIST_VIEW'
    },
    {
        path: '/branch-management/add-branch',
        element: AddNewBranch,
        screenKeyName: 'ADD_BRANCH'
    },
    {
        path: '/branch-management/:id/edit',
        element: EditBranch,
        screenKeyName: 'EDIT_UPDATE_BRANCH'
    },
    {
        path: '/branch-management/:id/view',
        element: ViewBranchDetails,
        screenKeyName: 'VIEW_BRANCH_DETAILS'
    },
    // Lab Users
    {
        path: '/configuration/users',
        element: Users,
        screenKeyName: 'VIEW_LAB_USERS_LIST'
    },
    {
        path: '/configuration/users/:id/view',
        element: ViewUsersrDetails,
        screenKeyName: 'VIEW_USER_DETAILS'
    },
    {
        path: '/configuration/users/:id/edit',
        element: EditUserData,
        screenKeyName: 'EDIT_UPDATE_USER'
    },
    {
        path: '/configuration/users/:id/reset-password',
        element: RestUserPassword,
        screenKeyName: 'RESET_USER_PASSWORD'
    },

    { path: '/configuration/users/add-user', element: AddUser, screenKeyName: 'ADD_LAB_USER' },

    //   /configuration/cost-management
    //    Reports
    {
        path: '/report',
        element: ReportsDashboard,
        screenKeyName: 'REPORTS_AND_LOGS'
    },
    {
        path: '/report/sample-logs',
        element: SampleLogReport,
        screenKeyName: 'VIEW_SAMPLE_LOGS'
    },
    {
        path: '/report/audit-log',
        element: AuditLogReport,
        screenKeyName: 'VIEW_SYSTEM_LOGS'
    },
    {
        path: '/report/system-audit-trail',
        element: SystemAuditTrail,
        screenKeyName: 'VIEW_SYSTEM_LOGS'
    },
    // Test Request
    { path: '/sample-requests', element: ManageTestRequest, screenKeyName: 'SAMPLE_REQUESTS' },
    { path: '/sample-requests/test-requests', element: TestRequests, screenKeyName: 'VIEW_TEST_REQUEST_LIST' },
    { path: '/sample-requests/adhoc-generate-sample-id', element: GeneratedSampleId, screenKeyName: 'VIEW_AD_HOC_SAMPLE_ID_LIST' },
    // Test Request Template
    { path: '/sample-requests/test-templates', element: TestTemplateList, screenKeyName: 'VIEW_TEST_TEMPLATE_LIST' },
    { path: '/sample-requests/test-templates/add-template', element: AddTestTemplate, screenKeyName: 'CREATE_TEST_TEMPLATE' },
    { path: '/sample-requests/test-templates/:id/view-template', element: ViewTemplateDetails, screenKeyName: 'VIEW_TEMPLATE_DETAILS' },
    { path: '/sample-requests/test-templates/:id/edit-template', element: EditTestTemplate, screenKeyName: 'EDIT_UPDATE_TEMPLATE' },

    { path: '/sample-requests/test-requests/add-request', element: NewTestSample, screenKeyName: 'CREATE_TEST_REQUEST' },
    { path: '/sample-requests/test-requests/:test_request_id/edit', element: EditTestSample, screenKeyName: 'EDIT_UPDATE_TEST_REQUEST' },
    {
        path: '/sample-requests/test-requests/:test_request_id/request_details',
        element: ViewTestRequest,
        screenKeyName: 'VIEW_TEST_REQUEST_DETAILS'
    },
    // Track Your Pickups
    { path: '/manage-pickups/maps/:id/tracking', element: MapPage, screenKeyName: 'GAIAPOD_MANAGEMENT' },
    { path: '/manage-pickups', element: ManagePickups, screenKeyName: 'GAIAPOD_MANAGEMENT' },
    { path: '/manage-pickups/tracking', element: TrackingList, screenKeyName: 'VIEW_TRACKING_LIST' },
    { path: '/manage-pickups/tracking/:trackingId', element: TrackingHistoryPage, screenKeyName: 'VIEW_TRACKING_DETAILS' },
    { path: '/manage-pickups/lost-items-list', element: LostItemsList, screenKeyName: 'VIEW_LOST_SAMPLES_LIST' },
    { path: '/manage-pickups/gaiapod-device-management', element: GaiapodList, screenKeyName: 'VIEW_GAIAPOD_DEVICE_LIST' },
    { path: '/manage-pickups/gaiapod-device-management/:id/view-details', element: ViewGaiapod, screenKeyName: 'VIEW_GAIAPOD_DEVICE_LIST' },
    // /lost-items-list
    // Track Your Pickups
    // Lab Management
    { path: '/sample-management', element: ManageLabTest, screenKeyName: 'SAMPLE_MANAGEMENT' },
    { path: '/sample-management/incoming-samples', element: Intransit, screenKeyName: 'VIEW_INCOMING_SAMPLE_LIST' },

    { path: '/sample-management/sample-receipt-list', element: LabTestUnvalidList, screenKeyName: 'VIEW_SAMPLE_RECEIPT_LIST' },
    { path: '/sample-management/result-entry', element: ScheduledList, screenKeyName: 'VIEW_VALIDATED_SAMPLE_LIST' },
    {
        path: '/sample-management/result-entry/:test_request_id/:requested_test_id/:lab_test_id/result-entry',
        element: ResultEntry,
        screenKeyName: 'RESULT_ENTRY'
    },
    {
        path: '/sample-management/result-entry/:test_request_id/:test_type/:status/grouped-result-entry',
        element: ResultEntryGrouped,
        screenKeyName: 'RESULT_ENTRY'
    },
    { path: '/sample-management/result-validation', element: ResultGenerationList, screenKeyName: 'RESULT_VALIDATION' },

    {
        path: '/sample-management/result-validation/:test_request_id/:requested_test_id/:lab_test_id/view',
        element: ResultViewPrint,
        screenKeyName: 'GENERATE_CERTIFICATE_AUTHORISE_COA'
    },
    {
        path: '/sample-management/result-validation/:test_request_id/:test_type/:lab_test_id/view-all',
        element: ResultViewPrintGroup,
        screenKeyName: 'GENERATE_CERTIFICATE_AUTHORISE_COA'
    },

    {
        path: '/sample-management/result-validation/:test_request_id/:requested_test_id/:lab_test_id/edit',
        element: ResultEntry,
        screenKeyName: 'EDIT_SAMPLE_RESULT_ENTRY'
    },
    {
        path: '/sample-management/result-validation/:test_request_id/:test_type/:status/edit_grouped',
        element: ResultEntryGrouped,
        screenKeyName: 'EDIT_SAMPLE_RESULT_ENTRY'
    },
    { path: '/sample-management/:test_request_id/splitting', element: SampleSplitting, screenKeyName: 'CAN_VALIDATE_SAMPLE' },

    { path: '/sample-management/:test_request_id/non-conformance', element: NonConfermance, screenKeyName: 'CAN_VALIDATE_SAMPLE' },
    {
        path: '/sample-management/retain-sample',
        element: Archival,
        screenKeyName: 'VIEW_RETAINED_SAMPLE_LIST'
    },
    {
        path: '/sample-management/archived-samples',
        element: Disposal,
        screenKeyName: 'VIEW_ARCHIVED_SAMPLES_LIST'
    },
    {
        path: '/sample-management/nonconforming-samples',
        element: UnfitSample,
        screenKeyName: 'VIEW_NON_CONFORMING_SAMPLE_LIST'
    },
    {
        path: '/sample-management/nonconforming-samples/:test_request_id/edit',
        element: NonConfermance,
        screenKeyName: 'EDIT_UPDATE_NON_CONFORMING_REPORT'
    },
    // Financial Management
    {
        path: '/financial-management',
        element: FinancilaDashboard,
        screenKeyName: 'FINANCIAL_MANAGEMENT'
    },
    //    cost
    {
        path: '/financial-management/cost-management',
        element: CostManagement,
        screenKeyName: ['VIEW_COSTING_CARD_TEMPLATES_LIST', 'VIEW_CUSTOMER_COSTING_CARD_TEMPLATES']
    },
    // {
    //     path: '/financial-management/cost-management',
    //     element: CostManagement,
    //     screenKeyName: 'VIEW_CUSTOMER_COSTING_CARD_TEMPLATES'
    // },
    {
        path: '/financial-management/cost-management/add-costing',
        element: AddCostingCard,
        screenKeyName: 'CREATE_COSTING_CARD_TEMPLATE'
    },
    {
        path: '/financial-management/invoice-management',
        element: BillingAndInvoiceManagement,
        screenKeyName: 'VIEW_INVOICE_LIST'
    },
    {
        path: '/financial-management/invoice-management/:id/invoice-view',
        element: InvoiceDetails,
        screenKeyName: 'VIEW_INVOICE_DETAILS'
    },
    {
        path: '/financial-management/invoice-management/:id/invoice-edit',
        element: InvoiceEdit,
        screenKeyName: 'EDIT_UPDATE_INVOICE'
    },
    {
        path: '/financial-management/invoice-management/create-invoice',
        element: CreateNewInvoice,
        screenKeyName: 'CREATE_INVOICE'
    },
    {
        path: '/financial-management/invoice-details',
        element: InvoiceDetailsReport,
        screenKeyName: 'INVOICE_EDIT'
    },
    {
        path: '/financial-management/price-change-log',
        element: PricingManagement,
        screenKeyName: 'VIEW_PRICE_CHANGE_LOGS'
    },
    {
        path: '/configuration/role-permissions/:id/:roleName',
        element: PermissionList,
        screenKeyName: 'UPDATE_ROLE_PERMISSIONS'
    }
];

export default MapRoutes;
